import { ArrowRight, MessageCircle } from "lucide-react";

export default function CTASection() {
  const wa = "https://wa.me/64221012443";
  return (
    <section data-testid="cta-section" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-teal-400/10 via-[#0a1530] to-gold/5 pointer-events-none" />
      <div className="absolute inset-0 tribal-pattern opacity-40 pointer-events-none" />

      <div className="relative max-w-[1100px] mx-auto px-6 md:px-12 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-gold font-semibold">
          Let's build it
        </p>
        <h2 className="mt-4 font-display uppercase text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[0.95]">
          Ready to dress your <br />
          community with <span className="text-teal-400">pride?</span>
        </h2>
        <p className="mt-6 text-zinc-400 text-lg max-w-2xl mx-auto">
          Tell us about your project and we'll come back with a free design
          mockup and quote within 24 hours.
        </p>

        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <a
            href="#contact"
            data-testid="cta-section-design"
            className="btn-primary inline-flex items-center gap-2"
          >
            Get Free Design Mockup
            <ArrowRight size={18} />
          </a>
          <a
            href={wa}
            target="_blank"
            rel="noreferrer"
            data-testid="cta-section-message"
            className="btn-secondary inline-flex items-center gap-2"
          >
            <MessageCircle size={18} />
            Message Us
          </a>
        </div>
      </div>
    </section>
  );
}
